import { render } from "./RenduDesktop.vue?vue&type=template&id=36581343"
import script from "./RenduDesktop.vue?vue&type=script&lang=js"
export * from "./RenduDesktop.vue?vue&type=script&lang=js"

import "./RenduDesktop.vue?vue&type=style&index=0&id=36581343&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__